export enum TemplateMessageTypeDTO {
    Email = "Email",
    SMS = "SMS",
    UiPush = "UiPush",
    AdminPush = "AdminPush"
}
